<template>
  <div class="mb-5">
    <div class="mt-3 mb-5 underline">
      1 약관동의
      <mdb-icon  icon="chevron-right" class="mx-4" />
      2 본인 인증
      <mdb-icon  icon="chevron-right" class="mx-4" />
      <span class=" page-title">3 회원 정보</span>
      <mdb-icon  icon="chevron-right" class="mx-4" />
      4 가입 완료
    </div>
    <mdb-row>
      <mdb-col class="mx-auto" md="8">
        <mdb-card class="px-4">
          <mdb-card-body>
            <mdb-card-title><mdb-icon  icon="user-plus" /> 회원 가입</mdb-card-title>
            <mdb-card-text>
              <form>
                훈련 선택:
                <select v-model="user.training" class="input-underline">
                  <option v-for="t in trainings" :key="t._id"
                    :value="t">{{short(t.name)}}</option>
                </select>
                <div class="clearfix">
                  <div class="float-left w-70">
                    <mdb-input class="mb-1 w-100" label="사용자 ID*" v-model="user.userId"/>
                  </div>
                  <div class="float-right">
                    <mdb-btn icon="check" color="primary" class="p-1 m-0 mt-4" @click="isexist"> 중복체크 </mdb-btn>
                  </div>
                </div>
                <div :class="{'red-text' : !idcheck}">{{checkMessage}}</div>
                <mdb-input label="비밀번호*"  class="w-50" type="password" v-model="user.password"/>
                <mdb-input label="비밀번호 확인*"  class="w-50" type="password" v-model="password2"/>
                <mdb-input label="이름*"  class="w-50" v-model="user.name" />
                <div> 성별:
                  <label><input type="radio" v-model="user.gender" value="남"> 남</label>
                  <label class="ml-3"><input type="radio" v-model="user.gender" value="여"> 여</label>
                </div>
                <mdb-input label="email*"  class="w-60" type="email" v-model="user.email"/>
                <mdb-input label="전화번호(010-xxxx-xxxx)"   class="w-60" v-model="cellphone"/>
                <mdb-input label="주소" v-model="user.address"/>
                <div class="text-center">
                  <mdb-btn icon="check" @click="join" :disabled="!isOk">확인</mdb-btn>
                </div>
              </form>
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mdbInput, mdbBtn, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'JoinProfileEdit',
  components: { mdbInput, mdbBtn, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbCardText },
  data: () => ({
    user: {
      cellPhone: { number1: '', number2: '', number3: '' }
    },
    trainings: [],
    cellphone: '',
    password2: '',
    idcheck: false,
    checkMessage: 'ID 중복 체크를 해야 합니다.'
  }),
  computed: {
    ...mapState('auth', ['org']),
    userId () { return this.user.userId },
    isOk () {
      return this.user.userId && this.user.password && this.password2 && this.idcheck && this.user.name && this.user.email
    }
  },
  methods: {
    ...mapActions('auth', ['']),
    async join () {
      if (this.user.password !== this.password2) {
        return alert('비밀번호 확인이 다릅니다.')
      }
      if (this.cellphone.trim()) {
        const numbers = this.cellphone.split('-')
        if (numbers.length !== 3) {
          return alert('전화번호 양식이 올바르지 않습니다.')
        }
        this.user.cellPhone.number1 = numbers[0]
        this.user.cellPhone.number2 = numbers[1]
        this.user.cellPhone.number3 = numbers[2]
      }
      if (!confirm('저장할까요?')) return
      this.user.role = 'STUDENT'
      this.user.status = '훈련중'
      await this.$Auth.join(this.user)
      this.$router.push({ name: 'JoinComplete' })
    },
    short (name) {
      return name.substr(0, 40)
    },
    async isexist () {
      if (!this.user.userId) {
        return alert('사용자 ID를 입력하세요.')
      }
      const { exists } = await this.$Auth.isexist(this.user.userId)
      if (exists) {
        this.checkMessage = this.user.userId + '는 이미 사용 중인 ID입니다.'
      } else {
        this.checkMessage = '사용 가능한 ID입니다.'
      }
      this.idcheck = !exists
    },
    async load () {
      const prefix = this.$route.params.org
      const org = await this.$Org.get({ prefix })
      if (org) {
        this.trainings = await this.$Training.recruit({ org: org._id })
      }
    }
  },
  watch: {
    userId () {
      this.checkMessage = 'ID 중복 체크를 해야 합니다.'
      this.idcheck = false
    },
    org () { this.load() }
  },
  async created () { this.load() }
}
</script>
